import { Icon } from "@iconify/react";
import { Button, Card, Grid, message, Pagination, Table, Tag, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { historyLogService } from "../../services/history-log.service";
import useTitleStore from "../../store/titleStore";
import { useTableHeight } from "../../hooks/useTableHeight";
import UpdatedByCell from "../../components/UpdatedByCell";

export default function HistoryLogIndex() {
  const breakpoint = Grid.useBreakpoint();

  const navigate = useNavigate();
  const { setTitle } = useTitleStore();
  const tableHeight = useTableHeight(420);

  const [messageApi, contextHolder] = message.useMessage();
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    filter: [],
  });

  const {
    data: logData,
    isLoading,
    isRefetching,
  } = useQuery({
    queryKey: ["log", dataParams],
    queryFn: () => historyLogService.fetchAll(dataParams),
    placeholderData: keepPreviousData,
  });

  useEffect(() => {
    setTitle("Data Log");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePage = (page, pageSize) => {
    setDataParams({
      ...dataParams,
      limit: pageSize,
      page,
    });
  };

  const columns = [
    {
      title: "No",
      align: "center",
      width: breakpoint.md ? 80 : 40,
      render: (text, record, index) => index + 1,
      fixed: breakpoint.md && "left",
    },
    {
      title: "Module",
      dataIndex: "module",
      width: 180,
      fixed: breakpoint.md && "left",
      render: (val) => (
        <Typography.Text style={{ fontWeight: 600 }}>{val}</Typography.Text>
      ),
    },
    {
      title: "Aksi",
      dataIndex: "action",
      width: 120,
      render: (val) => {
        switch (val) {
          case "CREATE":
            return <Tag color="success">{val}</Tag>;
          case "UPDATE":
            return <Tag color="blue">{val}</Tag>;
          case "DELETE":
            return <Tag color="red">{val}</Tag>;
        }
      },
    },
    {
      title: "Updated By",
      width: 120,
      render: (val) => <UpdatedByCell value={val} />,
    },
    {
      className: "last-cell-p",
      title: "Detail",
      align: "right",
      width: 60,
      fixed: "right",
      render: (record) => (
        <Button
          icon={<Icon icon="solar:eye-bold-duotone" width="18" height="18" />}
          color="default"
          variant="filled"
          onClick={() => navigate("/history-log/detail/" + record.uuid)}
        />
      ),
    },
  ];

  return (
    <Card
      styles={{
        body: {
          paddingLeft: 0,
          paddingRight: 0,
        },
      }}
    >
      {contextHolder}
      <Table
        columns={columns}
        pagination={false}
        size="small"
        loading={isLoading || isRefetching}
        rowKey={"id"}
        scroll={{ y: tableHeight }}
        dataSource={logData?.data}
      />
      <Pagination
        style={{ marginInline: 24, marginTop: 16 }}
        total={logData?.pagination?.total}
        showSizeChanger={{
          showSearch: false,
        }}
        pageSizeOptions={["10", "20", "50"]}
        current={logData?.pagination?.page}
        pageSize={dataParams.limit}
        align="end"
        onChange={handleChangePage}
      />
    </Card>
  );
}
